import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';

export enum IconName {
  arrowFromBracket = 'arrowFromBracket',
  building = 'building',
  user = 'user',
  trash = 'trash',
  edit = 'edit',
  check = 'check',
  document = 'document',
  video = 'video',
  text = 'text',
  image = 'image',
  sound = 'sound',
  rotate = 'rotate',
  back = 'back',
  embed = 'embed',
  grip = 'grip',
  save = 'save',
  plus = 'plus',
  bold = 'bold',
  italic = 'italic',
  subscript = 'subscript',
  superscript = 'superscript',
  search = 'search',
  star = 'star',
  sliders = 'sliders',
  squareCheck = 'squareCheck',
  circleCheck = 'circleCheck',
  filePdf = 'filePdf',
  copy = 'copy',
  upDownLeftRight = 'upDownLeftRight',
  arrowPointer = 'arrowPointer',
  circleXmark = 'circleXmark',
  close = 'close',
  key = 'key',
  mail = 'mail',
  paperPlane = 'paperPlane',
  alertTriangle = 'alertTriangle',
  powerpoint = 'powerpoint',
  slideshare = 'slideshare',
  vimeo = 'vimeo',
  youtube = 'youtube',
  desktop = 'desktop',
  chevronDown = 'chevronDown',
  arrowUpDownLeftRight = 'arrowUpDownLeftRight',
  square = 'square',
  cirlce = 'circle',
  pdf = 'pdf',
  play = 'play',
  pause = 'pause',
  vocabulary = 'vocabulary',
  flashcards = 'flashcards',
}

const icons = {
  [IconName.arrowFromBracket]: () =>
    import('@fortawesome/free-solid-svg-icons/faArrowRightFromBracket').then((mod) => mod.faArrowRightFromBracket),
  [IconName.building]: () => import('@fortawesome/free-solid-svg-icons/faBuilding').then((mod) => mod.faBuilding),
  [IconName.user]: () => import('@fortawesome/free-solid-svg-icons/faUsers').then((mod) => mod.faUsers),
  [IconName.trash]: () => import('@fortawesome/free-solid-svg-icons/faTrash').then((mod) => mod.faTrash),
  [IconName.edit]: () => import('@fortawesome/free-solid-svg-icons/faPenToSquare').then((mod) => mod.faPenToSquare),
  [IconName.check]: () => import('@fortawesome/free-solid-svg-icons/faCircleCheck').then((mod) => mod.faCircleCheck),
  [IconName.document]: () => import('@fortawesome/free-solid-svg-icons/faFileLines').then((mod) => mod.faFileLines),
  [IconName.video]: () => import('@fortawesome/free-solid-svg-icons/faVideo').then((mod) => mod.faVideo),
  [IconName.text]: () => import('@fortawesome/free-solid-svg-icons/faFileLines').then((mod) => mod.faFileLines),
  [IconName.image]: () => import('@fortawesome/free-solid-svg-icons/faImage').then((mod) => mod.faImage),
  [IconName.sound]: () => import('@fortawesome/free-solid-svg-icons/faHeadphones').then((mod) => mod.faHeadphones),
  [IconName.vocabulary]: () => import('@fortawesome/free-solid-svg-icons/faLanguage').then((mod) => mod.faLanguage),
  [IconName.flashcards]: () => import('@fortawesome/free-solid-svg-icons/faArrowRightArrowLeft').then((mod) => mod.faArrowRightArrowLeft),
  [IconName.rotate]: () => import('@fortawesome/free-solid-svg-icons/faRotate').then((mod) => mod.faRotate),
  [IconName.back]: () => import('@fortawesome/free-solid-svg-icons/faChevronLeft').then((mod) => mod.faChevronLeft),
  [IconName.embed]: () => import('@fortawesome/free-solid-svg-icons/faCode').then((mod) => mod.faCode),
  [IconName.grip]: () => import('@fortawesome/free-solid-svg-icons/faGrip').then((mod) => mod.faGrip),
  [IconName.save]: () => import('@fortawesome/free-solid-svg-icons/faCloudArrowUp').then((mod) => mod.faCloudArrowUp),
  [IconName.plus]: () => import('@fortawesome/free-solid-svg-icons/faPlus').then((mod) => mod.faPlus),
  [IconName.bold]: () => import('@fortawesome/free-solid-svg-icons/faBold').then((mod) => mod.faBold),
  [IconName.italic]: () => import('@fortawesome/free-solid-svg-icons/faItalic').then((mod) => mod.faItalic),
  [IconName.subscript]: () => import('@fortawesome/free-solid-svg-icons/faSubscript').then((mod) => mod.faSubscript),
  [IconName.superscript]: () =>
    import('@fortawesome/free-solid-svg-icons/faSuperscript').then((mod) => mod.faSuperscript),
  [IconName.search]: () => import('@fortawesome/free-solid-svg-icons/faSearch').then((mod) => mod.faSearch),
  [IconName.star]: () => import('@fortawesome/free-solid-svg-icons/faStar').then((mod) => mod.faStar),
  [IconName.sliders]: () => import('@fortawesome/free-solid-svg-icons/faSliders').then((mod) => mod.faSliders),
  [IconName.squareCheck]: () =>
    import('@fortawesome/free-solid-svg-icons/faSquareCheck').then((mod) => mod.faSquareCheck),
  [IconName.circleCheck]: () =>
    import('@fortawesome/free-solid-svg-icons/faCircleCheck').then((mod) => mod.faCircleCheck),
  [IconName.filePdf]: () => import('@fortawesome/free-solid-svg-icons/faFilePdf').then((mod) => mod.faFilePdf),
  [IconName.copy]: () => import('@fortawesome/free-solid-svg-icons/faCopy').then((mod) => mod.faCopy),
  [IconName.upDownLeftRight]: () =>
    import('@fortawesome/free-solid-svg-icons/faUpDownLeftRight').then((mod) => mod.faUpDownLeftRight),
  [IconName.arrowPointer]: () =>
    import('@fortawesome/free-solid-svg-icons/faArrowPointer').then((mod) => mod.faArrowPointer),
  [IconName.circleXmark]: () =>
    import('@fortawesome/free-solid-svg-icons/faCircleXmark').then((mod) => mod.faCircleXmark),
  [IconName.close]: () => import('@fortawesome/free-solid-svg-icons/faTimes').then((mod) => mod.faTimes),
  [IconName.key]: () => import('@fortawesome/free-solid-svg-icons/faKey').then((mod) => mod.faKey),
  [IconName.mail]: () => import('@fortawesome/free-solid-svg-icons/faEnvelope').then((mod) => mod.faEnvelope),
  [IconName.paperPlane]: () => import('@fortawesome/free-solid-svg-icons/faPaperPlane').then((mod) => mod.faPaperPlane),
  [IconName.alertTriangle]: () =>
    import('@fortawesome/free-solid-svg-icons/faExclamationTriangle').then((mod) => mod.faExclamationTriangle),
  [IconName.powerpoint]: () =>
    import('@fortawesome/free-solid-svg-icons/faFilePowerpoint').then((mod) => mod.faFilePowerpoint),
  [IconName.slideshare]: () =>
    import('@fortawesome/free-brands-svg-icons/faSlideshare').then((mod) => mod.faSlideshare),
  [IconName.vimeo]: () => import('@fortawesome/free-brands-svg-icons/faVimeo').then((mod) => mod.faVimeo),
  [IconName.youtube]: () => import('@fortawesome/free-brands-svg-icons/faYoutube').then((mod) => mod.faYoutube),
  [IconName.desktop]: () => import('@fortawesome/free-solid-svg-icons/faDesktop').then((mod) => mod.faDesktop),
  [IconName.chevronDown]: () =>
    import('@fortawesome/free-solid-svg-icons/faChevronDown').then((mod) => mod.faChevronDown),
  [IconName.arrowUpDownLeftRight]: () =>
    import('@fortawesome/free-solid-svg-icons/faArrowsUpDownLeftRight').then((mod) => mod.faArrowsUpDownLeftRight),
  download: () => import('@fortawesome/free-solid-svg-icons/faDownload').then((mod) => mod.faDownload),
  [IconName.square]: () => import('@fortawesome/free-solid-svg-icons/faSquare').then((mod) => mod.faSquare),
  [IconName.cirlce]: () => import('@fortawesome/free-solid-svg-icons/faCircle').then((mod) => mod.faCircle),
  [IconName.pdf]: () => import('@fortawesome/free-solid-svg-icons/faFilePdf').then((mod) => mod.faFilePdf),
  [IconName.play]: () => import('@fortawesome/free-solid-svg-icons/faPlay').then((mod) => mod.faPlay),
  [IconName.pause]: () => import('@fortawesome/free-solid-svg-icons/faPause').then((mod) => mod.faPause),
};

export default function MemreIcon({
  iconName,
  color,
  fontSize = '0.8em',
  style = {},
}: {
  iconName: IconName;
  color?: string;
  fontSize?: string;
  style?: any;
}) {
  const [icon, setIcon] = useState<any>(null);

  useEffect(() => {
    if (iconName && icons[iconName]) {
      // @ts-ignore
      icons[iconName]().then((iconModule) => {
        setIcon(iconModule);
      });
    }
  }, [iconName]);

  return icon ? <FontAwesomeIcon style={{ fontSize, color, ...style }} icon={icon} /> : null;
}
